import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import config from 'constants/config'
import { TOUR_STYLED_PRODUCT_TYPE_TITLES } from 'constants/tours'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import type { ComponentProps } from 'react'
import React, { useCallback } from 'react'

export type TourStyledSignatureSeriesProductTypeInfoModalResult = 'primary-action' | undefined

type InheritedModalProps = Pick<ComponentProps<typeof Modal>, 'primaryActionText' | 'primaryActionTo'>

type Props = InheritedModalProps

function TourStyledSignatureSeriesProductTypeInfoModal({
  primaryActionText,
  primaryActionTo,
}: Props) {
  const modalElement = useModalElementContext<TourStyledSignatureSeriesProductTypeInfoModalResult>()

  const handlePrimaryClick = useCallback(() => {
    modalElement.resolve('primary-action')
  }, [modalElement])

  return <Modal
    size="L"
    title={<>{config.brandConfig.name} Tour Styles</>}
    subtitle={TOUR_STYLED_PRODUCT_TYPE_TITLES.insider_series_tour}
    primaryActionText={primaryActionText}
    primaryActionTo={primaryActionTo}
    onPrimaryActionClick={!primaryActionTo ? handlePrimaryClick : undefined}
  >
    <VerticalSpacer gap={24}>
      <BodyText variant="medium" colour="neutral-two">
        These expertly curated journeys are co-designed by some of Australia's most trusted personalities and tastemakers. With itineraries built on authentic recommendations, Luxury Escapes' Insider Series takes you beyond the ordinary on an adventure designed by an expert.
      </BodyText>
      <Group
        direction="vertical"
        tabletDirection="horizontal"
        tabletHorizontalAlign="stretch"
        gap={24}
      >
        <VerticalSpacer gap={4}>
          <BodyText variant="medium" weight="bold" colour="neutral-one">
            Insider-Curated Itinerary
          </BodyText>
          <BodyText variant="medium" colour="neutral-two">
            Explore a destination through an expert's eyes, with curated experiences & hidden gems they love most.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={4}>
          <BodyText variant="medium" weight="bold" colour="neutral-one">
            Premium Accommodation
          </BodyText>
          <BodyText variant="medium" colour="neutral-two">
            Unwind in elevated hotels designed for enhanced comfort and quality.
          </BodyText>
        </VerticalSpacer>
        <VerticalSpacer gap={4}>
          <BodyText variant="medium" weight="bold" colour="neutral-one">
            Small-Group Journeys
          </BodyText>
          <BodyText variant="medium" colour="neutral-two">
            Travel in a small group for easier access to each destination.
          </BodyText>
        </VerticalSpacer>
      </Group>
    </VerticalSpacer>
  </Modal>
}

export default TourStyledSignatureSeriesProductTypeInfoModal
